import { View } from 'react-native';

import { Button, IconClose, IconStarRateFill, Text, XStack, tokens } from '@fhs/ui';
import { Badge } from '@fhs/ui/src/components/badge/badge';
import { HapticsNotificationType, hapticNotification } from '@fhs-legacy/frontend/src/utils/haptic';
import { REMOVE_REWARD, REWARD_IN_USE } from '@fhs-legacy/frontend/src/utils/test-ids';

import { IRewardInUseProps, styles } from './typesAndStyles';

export default function RewardInUse({ displayRewardTier, onRemoveReward }: IRewardInUseProps) {
  const displayPoints = displayRewardTier.points;

  const handleRemoveReward = () => {
    onRemoveReward();
    hapticNotification({ type: HapticsNotificationType.SUCCESS });
  };

  return (
    <XStack
      testID={REWARD_IN_USE}
      style={[styles.redeemContainer, styles.active]}
      accessibilityRole="text"
      accessibilityLabel={`Reward applied using ${displayPoints} points`}
    >
      <Badge>Reward</Badge>
      <View style={styles.spacer} />
      <View
        style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}
        accessibilityRole="text"
        accessibilityLabel={`Using ${displayPoints} points`}
      >
        <Button.Icon color={tokens.colors.$houseYellow}>
          <IconStarRateFill />
        </Button.Icon>
        <Text.Ui size="sm">Using</Text.Ui>
        <Text.Ui size="sm" weight="bold">
          {' ' + displayPoints + ' '}
        </Text.Ui>
        <Text.Ui size="sm">Points</Text.Ui>
      </View>
      <View style={styles.spacer} />
      <Button
        testID={REMOVE_REWARD}
        type="outline"
        onPress={handleRemoveReward}
        accessibilityRole="button"
        accessibilityLabel={`Remove reward using ${displayPoints} points`}
        accessibilityHint="Removes the applied reward from this item"
      >
        <Button.Icon>
          <IconClose />
        </Button.Icon>
      </Button>
    </XStack>
  );
}
